import { CC_AUTH_STORAGE_KEY } from '@/shared/infra/supabase'

type RegisterTabCloseRevokeParams = {
  getToken: () => Promise<string | null>
  revokeUrl: string
}

export function registerTabCloseRevoke(params: RegisterTabCloseRevokeParams): () => void {
  if (typeof window === 'undefined') {
    return () => {}
  }

  let cached: string | null = null

  const primeToken = () => {
    void params.getToken().then((token) => {
      cached = token
    })
  }

  primeToken()

  const fireRevoke = () => {
    if (!cached) return
    void fetch(params.revokeUrl, {
      method: 'POST',
      keepalive: true,
      headers: { Authorization: `Bearer ${cached}` },
      body: '',
    }).catch(() => {})
  }

  const clearAuthStorage = () => {
    try {
      window.localStorage.removeItem(CC_AUTH_STORAGE_KEY)
    } catch {
      return
    }
  }

  const handlePageHide = () => {
    fireRevoke()
    clearAuthStorage()
  }

  window.addEventListener('pagehide', handlePageHide)

  return () => {
    window.removeEventListener('pagehide', handlePageHide)
  }
}
